import Script from 'next/script'
import React, { useState, useEffect } from 'react'
import HeaderModuleYotpo from "./HeaderModuleYotpo";
import CharityCarousel from '../common/CharityCarousel';
import { generalConstants } from '@/utils/constants';
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import Srcset from '@/common/Srcset'
import GlobalLoader from '../common/GlobalLoader.js';

function YotpoHtml(props) {
  const { yotpo_hero_image, yotpo_hero_image_mobile, user_loggedIn } = props;

  const isMobile = useMediaQuery("(max-width: 767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");

  const [yotpoLoaded, setYotpoLoaded] = useState(false); 
  
useEffect(() => {
  if (typeof yotpoWidgetsContainer != "undefined" && typeof yotpoWidgetsContainer != undefined) {
    setYotpoLoaded(true)
  }
}, [yotpoLoaded]);

  useEffect(() => {
    const id = window.location.search;
    const urlParams = new URLSearchParams(id);
    const link_param = urlParams.get("refer_id");
    const element = document.getElementById(link_param);
    if (urlParams) {
      const interval = setInterval(() => {
        setTimeout(() => {
          if (element) {
            var elementPosition = element?.getBoundingClientRect().top;
            var offsetPosition =
              elementPosition +
              window.pageYOffset -
              headerOffset +
              element.scrollHeight;
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
            clearInterval(interval);
          }
        }, 1000);
      }, 1000);

      setTimeout(() => {
        clearInterval(interval); //clear interval in 10 mins
      }, 10000);

      return () => clearInterval(interval);
    }   
  }, []);

  return (
    <>
      <div className="yotpo-rewards-page-container">
        <div className="yotpo-header-section-container">
          {/* Banner */}
          <div
            className="yotpo-widget-instance"
            data-yotpo-instance-id={generalConstants.YOTPO_BANNER_INSTANCE_ID}
          ></div>
          <div className="gif_loader">
              <GlobalLoader />
          </div>
          {/* My Activity */}
          {!user_loggedIn && (
            <div className='yotpo-why-join'>
              {isTablet ? (
                <Srcset
                  src={`${process.env.NETLIFY_URL}/images/Yotpo/WhyJoin_Tablet.png`} // Tablet image
                  svgFile={true}
                  width="100%"
                  alt = "Why Join"
                  loading={yotpoLoaded ? "lazy" : "eager"} 
                />
              ) : isMobile ? (
                <Srcset
                  src={`${process.env.NETLIFY_URL}/images/Yotpo/WhyJoin_Mob.png`} // Mobile image
                  svgFile={true}
                  width="100%"
                  alt = "Why Join"
                  loading={yotpoLoaded ? "lazy" : "eager"} 
                />
              ) : (
                <Srcset
                  src={`${process.env.NETLIFY_URL}/images/Yotpo/WhyJoin_Desktop.png`} // Desktop image
                  svgFile={true}
                  width="100%"
                  alt = "Why Join"
                  loading={yotpoLoaded ? "lazy" : "eager"} 
                />
              )}
            </div>
          )}

          {/* My Activity */}
          <div
            className="yotpo-widget-instance"
            data-yotpo-instance-id={
              generalConstants.YOTPO_MY_ACTIVITY_INSTANCE_ID
            }
          ></div>
          {/* VIP Tiers */}
          <div
            className={`yotpo-vip-progresss-only ${
              !user_loggedIn ? "logged_out" : ""
            }`}
          >
            <div
              className="yotpo-widget-instance"
              data-yotpo-instance-id={
                generalConstants.YOTPO_VIP_TIERS_INSTANCE_ID
              }
            ></div>
          </div>
          {/* Earning Points */}
          <div
            className={`vip_earning_points ${
              !user_loggedIn ? "logged_out" : ""
            }`}
          >
            <div
              className="yotpo-widget-instance"
              data-yotpo-instance-id={
                generalConstants.YOTPO_EARNING_POINTS_INSTANCE_ID
              }
            ></div>
          </div>
          <div className={`yotpo-vip-tiers-only ${user_loggedIn ? 'logged_in' : ''}`}>
           <div
             className="yotpo-widget-instance"
              data-yotpo-instance-id={generalConstants.YOTPO_VIP_TIERS_INSTANCE_ID}
            ></div>
          </div>
          <div className="yotpo-spend-your-points">
            <div className="yotpo-spend-your-points-image-container">
              {isMobile ? (
                <Srcset
                  src={`${process.env.NETLIFY_URL}/images/Yotpo/Loyalty_SpendPoints_Mob.png`} // Mobile image
                  svgFile={true}
                  width="100%"
                  alt="Spend Your Points on rewards"
                  loading={yotpoLoaded ? "lazy" : "eager"} // Load after Yotpo content is loaded
                />
              ) : isTablet ? (
                <Srcset
                  src={`${process.env.NETLIFY_URL}/images/Yotpo/Loyalty_SpendYourPoints_Tablet_A_Test.png`} // Tab Image
                  svgFile={true}
                  width="100%"
                  alt="Spend Your Points on rewards"
                  loading={yotpoLoaded ? "lazy" : "eager"} 
                />
              ) : (
                <Srcset
                  src={`${process.env.NETLIFY_URL}/images/Yotpo/Loyalty_SpendPoints_Desktop.png`} // Desktop image
                  svgFile={true}
                  width="100%"
                  alt="Spend Your Points on rewards"
                  loading={yotpoLoaded ? "lazy" : "eager"} 
                />
              )}
              <h3 className="yotpo-points-title">Spend Your Points</h3>
            </div>
          </div>

          <CharityCarousel/>
          
          <div className="yotpo-Questions-section">
            <a href="/faq" rel="noopener noreferrer">
              {isMobile ? (
                <Srcset
                  src={`${process.env.NETLIFY_URL}/images/Yotpo/Questions_Mob.png`} // Mobile image
                  svgFile={true}
                  width="100%"
                  alt = "Frequently asked Questions"
                  loading={yotpoLoaded ? "lazy" : "eager"} 
                />
              ) : isTablet ? (
                <Srcset
                  src={`${process.env.NETLIFY_URL}/images/Yotpo/Questions_Tablet.png`} //Tab Image
                  svgFile={true}
                  width="100%"
                  alt = "Frequently asked Questions"
                  loading={yotpoLoaded ? "lazy" : "eager"} 
                />
              ) : (
                <Srcset
                  src={`${process.env.NETLIFY_URL}/images/Yotpo/Questions_Desktop.png`} // Desktop image
                  svgFile={true}
                  width="100%"
                  alt = "Frequently asked Questions"
                  loading={yotpoLoaded ? "lazy" : "eager"} 
                />
              )}
            </a>
          </div>
        </div>
      </div>
      <Script src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${process.env.YOTPO_REWARDS_JS_ID}`} />
    </>
  )
}

export default YotpoHtml
